import React from 'react';
import useShopifyProducts from '../hooks/useShopifyProducts';

import './ShopifyProductList.css';
import ProductCard from './ProductCard';  
import defaultImage from '../img/no-product.png';

function ShopifyProductList() {
  const products = useShopifyProducts(); 

  return (
    <div className="ProductListCompo">

      <div className="productContainer">
        {products.map((product) => (
          <div className="productCardContainer" key={product.node.id}>
            <ProductCard
              product={{
                name: product.node.title,
                description: product.node.description,
                compareAtPrice: product.node.variants.edges[0].node.compareAtPrice,
                price: product.node.variants.edges[0].node.price,
                image: product.node.images.edges[0]?.node?.originalSrc || defaultImage,
                inventoryQuantity: product.node.variants.edges[0].node.inventoryQuantity,
              }} 
            />
          </div>
        ))}
      </div>

    </div>
  );
}

export default ShopifyProductList;
